module.exports = __webpack_public_path__ + "img/Triangle.a08fcb18.svg";